import { LISTINGS_PAGE_TAGS } from '../../../constants/InvalidateConstants';

import type { QueryClient } from '@zg-rentals/react-query5';

// For flows that refresh caches by hand instead of through `meta.invalidates`.
export const invalidateListingsPageQueries = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    predicate: ({ meta }) => LISTINGS_PAGE_TAGS.some((tag) => meta?.tags?.includes(tag)),
  });
